<div style="display: flex; flex-direction: column; gap: 15px;">
  <div>
    <div class="profile-header">
      <img class="profile-avatar" [src]="userProfile?.pictureUrl || '/assets/layout/images/profile-image.png'" alt="Profile picture" />
      <div class="profile-info">
        <h2>{{ userProfile?.name || 'User' }}</h2>
        <p>{{ userProfile?.email }}</p>
      </div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row; gap: 15px;">

    <!-- basic user infomation -->
    <div style="min-width: 40%;">
      <p-panel [header]='"USERPROFILE.PERSONELINFOMATION" | translate'>
        <div class="profile-content">

          <form [formGroup]="UserMetaInfomation" (ngSubmit)="UpdateUserMetaInfomation()" class="password-form">

            <div Class="field">
              <label>{{"USERPROFILE.FIRSTNAME" | translate}}</label>
              <input pInputText formControlName="FirstName" readonly>
            </div>

            <div class="field">
              <label>{{"USERPROFILE.LASTNAME" | translate}}</label>
              <input pInputText formControlName="LastName" readonly>
            </div>

            <div class="field">
              <label>{{"USERPROFILE.EMAIL" | translate}}</label>
              <input pInputText formControlName="Email" readonly>
            </div>
            <div class="actions">
              <button pButton [hidden]="true" type="submit" [label]="'USERPROFILE.UPDATEPROFILE' | translate" [loading]="loading" [disabled]="loading || UserMetaInfomation.valid"></button>
            </div>

          </form>
        </div>
      </p-panel>
    </div>

    <!-- Password section -->
    <div style="min-width: 40%;">
      <p-panel [header]="'USERPROFILE.PASSWORDHEADER' | translate">
        <div class="profile-content">
          <h3>{{"password" | translate}}</h3>

          <form [formGroup]="passwordForm" (ngSubmit)="changePassword()" class="password-form">

            <div class="field">
              <label for="newPassword">{{"USERPROFILE.PASSWORDSECTION" | translate}}</label>
              <p-password tabIndex="1" id="newPassword" formControlName="newPassword" [toggleMask]="true" [feedback]="false" inputStyleClass="w-full" styleClass="w-full">
                <ng-template pTemplate="showicon">
                  <button pButton icon="pi pi-eye" (click)="newPassword.toggle"></button>
                </ng-template>
                <ng-template pTemplate="hideicon">
                  <button pButton icon="pi pi-eye-slash" (click)="newPassword.toggle"></button>
                </ng-template>

              </p-password>

              <small class="p-error" *ngIf="newPassword?.touched && newPassword?.hasError('required')"> {{"USERPROFILE.PASSWORDREQUIRED" | translate}}</small>
              <small class="p-error" *ngIf="newPassword?.touched && newPassword?.hasError('minlength')"> {{"USERPROFILE.PASSWORDMINLENGTH" | translate}} </small>
              <small class="p-error" *ngIf="newPassword?.touched && newPassword?.hasError('containsSpaces')"> {{"USERPROFILE.CONTAINSSPACES" | translate}} </small>
            </div>

            <div class="field">
              <label for="confirmPassword">{{ "USERPROFILE.CONFIRMPASSWORDSECTION" | translate}}</label>
              <p-password tabIndex="2" id="confirmPassword" formControlName="confirmPassword" [toggleMask]="true" [feedback]="false" inputStyleClass="w-full" styleClass="w-full">
                <ng-template pTemplate="showicon">
                  <button pButton icon="pi pi-eye" (click)="newPassword.toggle"></button>
                </ng-template>
                <ng-template pTemplate="hideicon">
                  <button pButton icon="pi pi-eye-slash" (click)="newPassword.toggle"></button>
                </ng-template>

              </p-password>

              <small class="p-error" *ngIf="confirmPassword?.touched && confirmPassword?.hasError('required')"> {{"USERPROFILE.PASSWORDCONFORMATION" | translate}} </small>
              <small id="achor" class="p-error" *ngIf="confirmPassword?.touched && passwordsDoNotMatch()"> {{"USERPROFILE.PASSWORDDONTMATCH" | translate}}</small>
            </div>

            <p-message *ngIf="successMessage" severity="success" [text]="successMessage"></p-message>
            <p-message *ngIf="errorMessage" severity="error" [text]="errorMessage"></p-message>

            <div class="actions">
              <button pButton type="submit" [label]="'USERPROFILE.UPDATEPASSWORD' |translate" icon="pi pi-lock" [loading]="loading" [disabled]="loading || passwordForm.invalid || passwordsDoNotMatch()"></button>
            </div>

          </form>
        </div>
      </p-panel>
    </div>
  </div>
</div>